module.exports = __webpack_public_path__ + "static/media/fr-FR.335c332a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/fr-FR.png
// module id = 944
// module chunks = 0